module.exports = __webpack_public_path__ + "img/couples-028.32b6c21d.jpg";